import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

const  SecurityInfoDetail=({saveData,updateData,renderForm,validateError,fieldPattern})=>{
  
   const dispatch=useDispatch()
  
   const onSelect=useCallback((e, {value,name})=>{
    dispatch(updateData({[name]:value?.trim()}))

    validateError&&validateError(
      {security:value}, {security:fieldPattern()?.transportTab?.security}
    )

    saveData({[name]:value || " "})
          
   },[updateData,saveData])
   
  return(
    renderForm && renderForm({onSelect})
  )
}
export default React.memo(SecurityInfoDetail)